/** Store Management — enums and display labels (mirrors /api/v1 store service). */

export const STORE_TYPES = [
  'MAIN_STORE',
  'PHARMACY',
  'WARD_STORE',
  'OT_STORE',
  'ICU_STORE',
  'DEPARTMENT_STORE',
  'SUB_STORE',
  'OTHER',
];

export const STORE_TYPE_LABELS = {
  MAIN_STORE: 'Main Store',
  PHARMACY: 'Pharmacy',
  WARD_STORE: 'Ward Store',
  OT_STORE: 'OT Store',
  ICU_STORE: 'ICU Store',
  DEPARTMENT_STORE: 'Department Store',
  SUB_STORE: 'Sub Store',
  OTHER: 'Other',
};

export const STORE_TYPE_PREFIX = {
  MAIN_STORE: 'ST',
  PHARMACY: 'PH',
  WARD_STORE: 'WD',
  OT_STORE: 'OT',
  ICU_STORE: 'IC',
  DEPARTMENT_STORE: 'DP',
  SUB_STORE: 'SS',
  OTHER: 'OT',
};

export const BIN_TYPES = [
  'SHELF',
  'RACK',
  'COLD',
  'CONTROLLED',
  'QUARANTINE',
  'GENERAL',
];

export const BIN_TYPE_LABELS = {
  SHELF: 'Shelf',
  RACK: 'Rack',
  COLD: 'Cold Storage',
  CONTROLLED: 'Controlled Drugs',
  QUARANTINE: 'Quarantine',
  GENERAL: 'General',
};

export const TXN_TYPES = [
  'OPENING_STOCK',
  'GOODS_RECEIPT',
  'VENDOR_RETURN',
  'REQUISITION',
  'ISSUE',
  'URGENT_ISSUE',
  'ISSUE_RETURN',
  'STOCK_ADJUSTMENT',
  'STOCK_TRANSFER',
  'CONSUMPTION',
  'WARD_CONSUMPTION',
  'PATIENT_SALE',
  'DISPENSE',
];

export const TXN_TYPE_LABELS = {
  OPENING_STOCK: 'Opening Stock',
  GOODS_RECEIPT: 'Goods Receipt',
  VENDOR_RETURN: 'Vendor Return',
  REQUISITION: 'Requisition',
  ISSUE: 'Issue',
  URGENT_ISSUE: 'Urgent Issue',
  ISSUE_RETURN: 'Issue Return',
  STOCK_ADJUSTMENT: 'Stock Adjustment',
  STOCK_TRANSFER: 'Stock Transfer',
  CONSUMPTION: 'Patient Consumption',
  WARD_CONSUMPTION: 'Ward Consumption',
  PATIENT_SALE: 'Patient Sale(OTC)',
  DISPENSE: 'Dispense',
};

/** Default transaction rules shown on new store form */
export const DEFAULT_ALLOWED_TRANSACTIONS = [
  { txn_type: 'GOODS_RECEIPT', is_allowed: false, requires_approval: false },
  { txn_type: 'STOCK_TRANSFER', is_allowed: true, requires_approval: false },
  { txn_type: 'DISPENSE', is_allowed: false, requires_approval: false },
  { txn_type: 'REQUISITION', is_allowed: true, requires_approval: false },
  { txn_type: 'ISSUE', is_allowed: true, requires_approval: false },
  { txn_type: 'CONSUMPTION', is_allowed: true, requires_approval: false },
  { txn_type: 'WARD_CONSUMPTION', is_allowed: true, requires_approval: false },
  { txn_type: 'PATIENT_SALE', is_allowed: true, requires_approval: false },
];

export const STORE_PAGE_SIZE = 25;

export const STORE_PRIMARY_TABS = [
  { id: 'details', label: 'Store Details' },
  { id: 'consumption', label: 'Consumption' },
];

export const STORE_CONSUMPTION_TABS = [
  { id: 'all', label: 'All' },
  { id: 'ward', label: 'Ward Consumption' },
  { id: 'patient', label: 'Patient Consumption' },
];

export const CONSUMPTION_TYPES = ['WARD', 'PATIENT'];

export const CONSUMPTION_TYPE_LABELS = {
  WARD: 'Ward',
  GENERAL: 'Ward', // legacy API value
  PATIENT: 'Patient',
};

export const ENCOUNTER_TYPES = ['IP', 'EMERGENCY', 'DAY CARE'];

export const STORE_DETAIL_TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'bins', label: 'Bins' },
  { id: 'transactions', label: 'Transactions' },
  { id: 'item-classes', label: 'Item Classes' },
  { id: 'reorder', label: 'Reorder' },
  { id: 'hierarchy', label: 'Hierarchy' },
];

export const STORE_FORM_STEPS = [
  { id: 'identity', label: 'Identity' },
  { id: 'flags', label: 'Store Flags' },
  { id: 'item-classes', label: 'Material group/Item classes' },
  { id: 'transactions', label: 'Transactions' },
  // { id: 'reorder', label: 'Reorder' },
];

export const STOCK_ADJUSTMENT_HUB_TABS = [
  { id: 'adjustments', label: 'Adjustments' },
  // { id: 'change-bin', label: 'Change Bin' },
  // { id: 'split-batch', label: 'Split Batch' },
];

export const STOCK_ADJUSTMENT_STATUSES = ['DRAFT', 'AUTHORIZED', 'CANCELLED'];

export const STOCK_ADJUSTMENT_TYPES = [
  { value: 'INCREASE', label: 'Increase' },
  { value: 'DECREASE', label: 'Decrease' },
];

export const GOODS_DISCARD_STATUSES = ['DRAFT', 'APPROVED', 'REJECTED', 'CANCELLED'];

export const GOODS_DISCARD_REASONS = [
  'Expired',
  'Damaged',
  'Contaminated',
  'Recalled',
  'Quality issue',
  'Other',
];
